import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRestaurant } from '../context/RestaurantContext';
import { Button, Result } from 'antd';
import { IMAGE_ROOT_URL } from '../constants';

const Thankyou = () => {
    const navigate = useNavigate();
    const { restaurantDetails } = useRestaurant();

    return (
        <div className=' flex flex-col w-full relative bg-gray-100 gap-24 h-screen'>
            <div className=' header-new flex justify-center items-center w-full sticky top-0 z-50'>
                <div className='logo-container flex justify-center items-center max-w-28'>
                    {restaurantDetails?.logo && (
                        <img
                            src={`${IMAGE_ROOT_URL}restaurant-properties/${restaurantDetails?.logo}`}
                            alt='primary'
                            className='max-h-11'
                        />
                    )}
                </div>
            </div>
            <div className='flex justify-center items-center z-99 flex-col gap-4'>
                <Result
                    status='success'
                    title='Order placed successfully!'
                    subTitle='Thank you for placing your order.
                    You order has reached our kitchen and will be served shortly.'
                    extra={
                        <Button type='primary' onClick={() => navigate('/')}>
                            Back to Main Menu
                        </Button>
                    }
                />
            </div>
        </div>
    );
};

export default Thankyou;
